<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />

    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="py-10">
      <div class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10">
        <div>
          <form
            ref="addCourseRef"
            class="rounded-2xl pt-10 px-6 md:px-10 pb-2 heightfix overflow-y-auto bg-white"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
            @submit.prevent="createCourse"
          >
            <div class="flex items-center justify-between flex-wrap">
              <h1
                class="py-2 text-xl text-center font-bold text-blues w-full md:w-auto"
              >
                Add New Course
              </h1>
              <router-link
                :to="{ name: 'AdminCoursess' }"
                class="bg-blues text-white rounded-lg hover:bg-[#18469d] hover:text-white text-sm font-semibold px-3 py-1 cursor-pointer"
                >Close</router-link
              >
            </div>

            <div class="py-10 flex flex-col gap-6">
              <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="batch_year" class="text-sm"
                    >Batch Year <span class="text-red-400">*</span></label
                  >
                  <select
                    id="batch_year"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>Select Batch</option>
                    <option
                      v-for="batch_year in batch_years"
                      :key="batch_year.year"
                      :value="batch_year.year"
                    >
                      {{ batch_year.year }} 
                    </option>
                  </select>
                </div> 
                <div class="flex flex-col gap-3">
                  <label for="program_name" class="text-sm flex gap-2"
                    >Program Name <span class="text-red-400">*</span> 
                    <font-awesome-icon
                      @click="isPrograms = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                    </label
                  >
                  <select
                    id="program_name"
                    required
                    @change="getProgramsFilter()"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                  <option value="" selected disabled>Select Programs</option>
                    <option
                      v-for="program in programs"
                      :key="program.id"
                      :value="program.id"
                    >
                      {{ program.name }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="department" class="text-sm flex gap-2"
                    >Departments <span class="text-red-400">*</span>

                    <font-awesome-icon
                      @click="isDepartment = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <select
                    id="department"
                    @change="getInstructorListByFilter(), getSemesterFilter()"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                  <option value="" selected disabled>Select Department</option>
                    <option
                      v-for="department in departments"
                      :key="department.id"
                      :value="department.id"
                    >
                      {{ department.name }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="semester" class="text-sm flex gap-2"
                    >Semester<span class="text-red-400">*</span>
                     <font-awesome-icon
                      @click="isSemesterAdd = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                    </label
                  >
                  <select 
                    id="semester"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                   
                    <option value="" selected disabled>Select Semester</option>
                    <option v-for="semester in semetser_list" :key="semester" :value="semester.id">{{ semester.semester }}</option> 
                   
                  </select>
                </div> 
              </div>


              <div class="grid grid-cols-1 md:grid-cols-2 gap-5"> 
                <div class="flex flex-col gap-3">
                  <label for="section" class="text-sm"
                    >Section <span class="text-red-400">*</span></label
                  >
                  <select 
                    id="section"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                   
                    <option value="" selected disabled>Select Section</option>
                    <option v-for="section in sections" :key="section" :value="section.id">{{ section.name }}</option> 
                  </select>
                  
                </div>

                <div class="flex flex-col gap-3">
                  <label for="faculty" class="text-sm"
                    >Select Faculty <span class="text-red-400">*</span></label
                  >
                  
                  <select
                    id="instructor_id"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>Select Faculty</option>
                    <option
                      v-for="instructor_list in instructor_lists"
                      :key="instructor_list.id"
                      :value="instructor_list.id"
                    >
                      {{ instructor_list.user.email }}
                    </option>
                  </select>
                </div>
              </div> -->

              <div
                v-for="(group, index) in formsDetails"
                :key="'group-' + index"
                class="grid grid-cols-1 md:grid-cols-2 gap-5 border-b-2 border-gray-300 pb-5"
              >
                <!-- Batch Year -->
                <div class="flex flex-col gap-3">
                  <label class="text-sm flex gap-2 items-center">
                    Batch Year <span class="text-red-400">*</span>

                    <font-awesome-icon
                      @click="openBatchPopup(index)"
                      class="text-green-500 cursor-pointer"
                      :icon="['fas', 'plus']"
                    />
                  </label>

                  <select
                    v-model="group.batch_id"
                    @change="onBatchChange(index, group.batch_id)"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                  >
                    <option value="">Select Batch</option>

                    <option
                      v-for="batch in batch_years"
                      :key="batch.id"
                      :value="batch.id"
                    >
                      {{ batch.year }}
                    </option>
                  </select>
                </div>
                <!-- Program Name -->
                <div class="flex flex-col gap-3">
                  <label class="text-sm flex gap-2 items-center">
                    Program <span class="text-red-400">*</span>

                    <font-awesome-icon
                      @click="group.batch_id && openProgramPopup(index)"
                      :icon="['fas', 'plus']"
                      class="p-1 rounded-full transition-all"
                      :class="
                        group.batch_id
                          ? 'text-green-500  cursor-pointer'
                          : 'text-gray-400  cursor-not-allowed'
                      "
                    />
                  </label>

                  <select
                    v-model="group.program_id"
                    @change="onProgramChange(index, group.program_id)"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                  >
                    <option value="">Select Program</option>

                    <option
                      v-for="program in group.programs"
                      :key="program.id"
                      :value="program.id"
                    >
                      {{ program.name }}
                    </option>
                  </select>
                </div>
                <!-- Department (Hidden - Auto Selected) -->
                <div class="hidden">
                  <select v-model="group.department_id">
                    <option
                      v-for="department in group.departments"
                      :key="department.id"
                      :value="department.id"
                    >
                      {{ department.name }}
                    </option>
                  </select>
                </div>

                <!-- Semester -->
                <div class="flex flex-col gap-3">
                  <label class="text-sm flex gap-2 items-center">
                    Semester <span class="text-red-400">*</span>

                    <font-awesome-icon
                      @click="group.program_id && openSemesterPopup(index)"
                      :icon="['fas', 'plus']"
                      class="p-1 rounded-full transition-all"
                      :class="
                        group.program_id
                          ? 'text-green-500   cursor-pointer'
                          : 'text-gray-400  cursor-not-allowed'
                      "
                    />
                  </label>

                  <select
                    v-model="group.semester_id"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                  >
                    <option value="">Select Semester</option>

                    <option
                      v-for="semester in group.semetser_list"
                      :key="semester.id"
                      :value="semester.id"
                    >
                      {{ semester.semester }}
                    </option>
                  </select>
                </div>

                <!-- Section (Common) -->
                <div class="flex flex-col gap-3">
                  <label class="text-sm flex gap-2 items-center">
                    Section <span class="text-red-400">*</span>

                    <font-awesome-icon
                      @click="openSectionPopup"
                      class="text-green-500 cursor-pointer"
                      :icon="['fas', 'plus']"
                    />
                  </label>

                  <select
                    v-model="group.section_id"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                  >
                    <option value="">Select Section</option>

                    <option
                      v-for="section in sections"
                      :key="section.id"
                      :value="section.id"
                    >
                      {{ section.name }}
                    </option>
                  </select>
                </div>
                <!-- Faculty (Multiple Select with Checkboxes) -->
                <div class="flex flex-col gap-3 w-full">
                  <label class="text-sm font-medium"
                    >Select Faculty <span class="text-red-400">*</span></label
                  >
                  <ul
                    class="w-full border rounded-lg shadow-md h-[150px] overflow-y-auto mt-1 p-2 space-y-2"
                    :class="
                      group.instructor_lists.length === 0
                        ? 'bg-gray-200'
                        : 'bg-white'
                    "
                  >
                    <li
                      v-for="instructor in group.instructor_lists"
                      :key="instructor.id"
                      class="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-1 rounded"
                    >
                      <input
                        type="checkbox"
                        :value="instructor.id"
                        v-model="group.instructor_id"
                        class="form-checkbox accent-blue-600"
                        :disabled="!group.semester_id"
                      />
                      <span>{{ instructor.user.email }}</span>
                    </li>
                  </ul>
                </div>
                <!-- Cancel Button for Dynamic Rows -->
                <div class="flex items-end justify-end" v-if="group.isDynamic">
                  <button
                    type="button"
                    @click="cancelForm(index)"
                    class="bg-red-400 text-white rounded-lg text-sm font-semibold px-3 py-1 cursor-pointer"
                  >
                    Cancel
                  </button>
                </div>
              </div>
              <div class="flex justify-end">
                <button
                  @click="addFormInput"
                  class="bg-blues text-white hover:bg-[#18469d] hover:text-white rounded-lg text-sm font-semibold px-3 py-2 cursor-pointer"
                >
                  Add New Program
                </button>
              </div>

              <!-- {{ formsDetails }} -->

              <!-- New Fields -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="credits" class="text-sm">Credits</label>
                  <input
                    id="credits"
                    type="number"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="exam_duration" class="text-sm flex gap-2"
                    >Exam Duration
                  </label>
                  <input
                    id="exam_duration"
                    type="number"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="cie" class="text-sm">CIE</label>
                  <input
                    id="cie"
                    type="number"
                    @input="addNumber"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="see" class="text-sm flex gap-2">SEE </label>
                  <input
                    id="see"
                    type="number"
                    @input="addNumber"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="total" class="text-sm flex gap-2">Total </label>
                  <input
                    id="total"
                    type="number"
                    disabled
                    class="bg-[#eaeaeb] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <!-- <div class="flex flex-col gap-3">
                  <label for="total_contact_hours" class="text-sm flex gap-2"
                    >Total Contact Hours 
                  </label>
                  <input
                    id="total_contact_hours"
                    type="number"
                    min="1" 
                    max="10"
                    @input="validateNumber('total_contact_hours')"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div> -->
                <!-- <div class="flex flex-col gap-3 hidden">
                  <label for="total_contact_hours" class="text-sm flex gap-2 items-center"
                    >Total Contact Hours 
                    <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                        HH:MM format
                        </div>
                      </div>
                  </label>
                  <input
                    id="total_contact_hours"
                    type="text"
                    maxlength="4"
                     @blur="convertTimeOnBlur"
                     placeholder="HH:MM"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div> -->

                <!-- <div class="flex flex-col gap-3">
                  <label for="no_of_contact_hours" class="text-sm flex gap-2"
                    >No of Contact Hours 
                  </label>
                  <input
                    id="no_of_contact_hours"
                    type="number"
                    min="1" 
                    max="10"
                    @input="validateNumber('no_of_contact_hours')"
                    
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex flex-col gap-3">
                  <label for="tutor_hours" class="text-sm flex gap-2"
                    >Tutor Hours 
                  </label>
                  <input
                    id="tutor_hours"
                    type="text"
                    @input="validateNumber('tutor_hours')"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex flex-col gap-3">
                  <label for="practical_hours" class="text-sm flex gap-2"
                    >Practical Hours 
                  </label>
                  <input
                    id="practical_hours"
                    type="text"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex flex-col gap-3">
                  <label for="ltp" class="text-sm flex gap-2"
                    >LTP 
                  </label>
                  <input
                    id="ltp"
                    type="text"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div> -->
              </div>

              <div class="grid grid-cols-1">
                <div class="flex flex-col gap-3">
                  <label for="title" class="text-sm"
                    >Title <span class="text-red-400">*</span></label
                  >
                  <input
                    id="title"
                    type="text"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label
                    for="course_code"
                    class="text-sm flex gap-1 items-center"
                    >Course Code <span class="text-red-400">*</span>
                  </label>
                  <input
                    id="course_code"
                    type="text"
                    maxlength="30"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                  <!-- <p v-if="errorMessage" class="text-red-500 text-sm mt-1">
                    {{ errorMessage }}
                  </p>
                  <p
                    v-if="errorgreenMessage"
                    class="text-green-500 text-sm mt-1"
                  >
                    {{ errorgreenMessage }}
                  </p> -->
                </div>

                <div class="flex flex-col gap-3">
                  <label for="category" class="text-sm flex gap-2"
                    >Course Type
                    <font-awesome-icon
                      @click="isCourseTypePopup = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <select
                    id="course_type"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>
                      Select Course Type
                    </option>
                    <option
                      v-for="type in courseTypeList"
                      :key="type.id"
                      :value="type.id"
                    >
                      {{ type.title }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="short-desc" class="text-sm"
                    >Course objective is to:
                    <span class="text-red-400">*</span></label
                  >
                  <textarea
                    id="short-desc"
                    required
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div>
                <div class="flex flex-col gap-1">
                  <label for="name">
                    Order
                    <span class="text-red-400">*</span>
                  </label>
                  <input
                    id="order"
                    type="text"
                    placeholder="e.g. 1"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    @input="
                      $event.target.value = $event.target.value.replace(
                        /\D/g,
                        '',
                      )
                    "
                  />
                  <span v-if="errors.ordered" class="text-red-500 text-xs mt-1">
                    {{ errors.ordered[0] }}
                  </span>
                </div>
              </div>

              <div class="flex flex-col gap-3">
                <label for="description" class="text-sm"
                  >Description <span class="text-red-400">*</span></label
                >
                <QuillEditor
                  style="height: 300px"
                  theme="snow"
                  class="border rounded-2xl"
                  toolbar="full"
                  :content="description"
                  contentType="html"
                />
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="language" class="text-sm flex gap-2"
                    >Language

                    <font-awesome-icon
                      @click="addLanguage = true"
                      class="text-base text-green-500 self-end mt-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <!-- <input
                    id="language"
                    type="text"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  /> -->
                  <select
                    id="languages"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option
                      v-for="lang in languageList"
                      :key="lang.id"
                      :value="lang.id"
                    >
                      {{ lang.title }}
                    </option>
                  </select>
                </div>

                <div class="flex flex-col gap-3">
                  <label for="requirement" class="text-sm"
                    >Requirements (if any)</label
                  >
                  <textarea
                    id="requirement"
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div>
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="thumbnail" class="text-sm"
                    >Thumbnail <span class="text-red-400">*</span></label
                  >
                  <input
                    id="thumbnail"
                    type="file"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                  <span v-if="errors.thumbnail" class="text-red-500 text-xs">
                    {{ errors.thumbnail[0] }}
                  </span>
                </div>

                <div class="flex flex-col gap-3 lg:gap-0">
                  <label for="video_url" class="text-sm flex gap-1 items-center"
                    >Upload Video
                    <!-- <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                        Only files below 500MB can be uploaded.
                        </div>
                      </div> -->
                  </label>

                  <div class="w-full mt-2">
                    <!-- uploadfileChunkNew -->
                    <!-- videoUploadURL(
                          'fileuploadvideo',
                          'uploaded_files_video'
                        ) -->

                    <form
                      enctype="multipart/form-data"
                      class="flex flex-col gap-2 w-full"
                      method="POST"
                      @submit.prevent="
                        uploadFilebyChunkNew(
                          'fileuploadvideo',
                          'video_url',
                          'video',
                        )
                      "
                    >
                      <label class="font-bold text-sm"
                        >Select video file to upload.</label
                      >

                      <div class="flex flex-row gap-2 w-full">
                        <input
                          type="file"
                          class="bg-gray-100 rounded-lg p-3 border-none outline-none w-full"
                          id="fileuploadvideo"
                          @change="CheckVideoSizeUpload"
                          accept="video/*"
                          required
                        />
                        <input
                          type="submit"
                          value="Upload"
                          id="submit"
                          class="text-white bg-blues rounded-lg text-sm font-bold px-4 py-2 cursor-pointer"
                        />
                      </div>

                      <p v-if="video_error" style="color: red">
                        {{ video_error }}
                      </p>
                      <!-- <div class="flex justify-end">
                       
                      </div> -->
                    </form>
                    <div id="statusCodeVideo" class="mt-2"></div>
                  </div>
                  <p class="pl-[100px] w-[50px]">(or)</p>
                  <p
                    class="text-black text-xs"
                    v-if="isValidUrlBool.video_url == false"
                  >
                    url.
                  </p>
                  <p
                    class="text-green-800 text-xs"
                    v-if="isValidUrlBool.video_url == true"
                  >
                    URL valid.
                  </p>
                  <input
                    id="video_url"
                    @change="isValidUrl('video_url')"
                    @input="isValidUrl('video_url')"
                    type="text"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <!-- <div class="flex flex-col gap-3">
                  <label for="level" class="text-sm">Level</label>
                  <select
                    id="level"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option
                      v-for="level in ['beginner', 'intermediate', 'advanced']"
                      :key="level"
                      :value="level"
                    >
                      {{ level }}
                    </option>
                  </select>
                </div> -->
              </div>
              <!-- <div class="flex flex-col gap-3">
                  <label for="outcome" class="text-sm">Outcome </label>
                  <textarea
                    id="outcome"
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div> -->

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3 w-full">
                  <label for="outcome" class="text-sm">Keywords</label>

                  <input
                    id="outcome"
                    maxlength="1000"
                    type="text"
                    v-model="keywords"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex flex-col gap-3 lg:gap-0 hidden">
                  <label for="pdf_urls" class="text-sm flex gap-1 items-center"
                    >Upload PDF
                    <div class="relative group" v-if="pdfDisabled">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <div
                        class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                      >
                        Please fill the keywords before uploading the PDF.
                      </div>
                    </div></label
                  >

                  <div
                    class="w-full mt-2"
                    :class="{ 'pointer-events-none opacity-60 ': pdfDisabled }"
                  >
                    <form
                      enctype="multipart/form-data"
                      class="flex flex-col gap-2 w-full"
                      method="POST"
                      @submit.prevent="
                        uploadFilebyChunkNew('fileuploadpdf', 'pdf_urls', 'pdf')
                      "
                    >
                      <label class="font-bold text-sm"
                        >Select pdf file to upload.</label
                      >

                      <div class="flex flex-row gap-2 w-full">
                        <input
                          type="file"
                          class="bg-gray-100 rounded-lg p-3 border-none outline-none w-full"
                          accept="application/pdf"
                          @change="CheckPdfSizeUpload"
                          id="fileuploadpdf"
                          required
                        />
                        <input
                          type="submit"
                          value="Upload"
                          id="submit"
                          class="text-white bg-blues rounded-lg text-sm font-bold px-4 py-2 cursor-pointer"
                        />
                      </div>

                      <p v-if="pdf_error" style="color: red">{{ pdf_error }}</p>
                    </form>
                    <div id="statusCodePdf" class="mt-2"></div>
                  </div>

                  <p class="pl-[100px] w-[50px]">(or)</p>
                  <p
                    class="text-black text-xs"
                    v-if="isValidUrlBool.pdf_urls == false"
                  >
                    url.
                  </p>
                  <p
                    class="text-green-800 text-xs"
                    v-if="isValidUrlBool.pdf_urls == true"
                  >
                    URL valid.
                  </p>
                  <input
                    @input="isValidUrl('pdf_urls')"
                    id="pdf_urls"
                    type="text"
                    :class="{ 'pointer-events-none opacity-60': pdfDisabled }"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex flex-col gap-3 lg:gap-0">
                  <label for="url_list" class="text-sm flex gap-1 items-center">
                    Upload PDF
                    <div class="relative group" v-if="pdfDisabled">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <div
                        class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                      >
                        Please fill the keywords before uploading the PDF.
                      </div>
                    </div>
                  </label>

                  <div
                    class="w-full mt-2"
                    :class="{ 'pointer-events-none opacity-60 ': pdfDisabled }"
                  >
                    <form
                      enctype="multipart/form-data"
                      class="flex flex-col gap-2 w-full"
                      @submit.prevent="uploadFilesSequential()"
                    >
                      <label class="font-bold text-sm"
                        >Select PDF file(s) to upload:</label
                      >

                      <div class="flex flex-row gap-2 w-full">
                        <input
                          type="file"
                          id="fileuploadpdf"
                          class="bg-gray-100 rounded-lg p-3 border-none outline-none w-full"
                          accept="application/pdf"
                          multiple
                          @change="checkPdfSizes"
                          required
                        />
                        <input
                          type="submit"
                          value="Upload"
                          class="text-white bg-blues rounded-lg text-sm font-bold px-4 py-2 cursor-pointer"
                        />
                      </div>

                      <p v-if="pdf_error" class="text-red-600 text-sm">
                        {{ pdf_error }}
                      </p>
                    </form>

                    <div
                      id="statusCodePdf"
                      class="mt-2 text-sm text-gray-700"
                    ></div>

                    <!-- URL display -->
                    <label class="text-sm mt-3">Uploaded URLs:</label>
                    <input
                      type="text"
                      v-model="url_list"
                      :class="{ 'pointer-events-none opacity-60': pdfDisabled }"
                      readonly
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />

                    <ol
                      class="mt-2 list-decimal pl-5"
                      :class="{ 'pointer-events-none opacity-60': pdfDisabled }"
                    >
                      <li
                        v-for="(url, index) in displayedUrls"
                        :key="index"
                        class="text-xs text-green-800 mb-1"
                      >
                        <a
                          :href="url"
                          target="_blank"
                          class="text-blue-600 hover:text-blue-800 hover:underline break-all"
                        >
                          {{ truncate(url, 50) }}
                        </a>
                      </li>
                    </ol>

                    <!-- Read More / Read Less Button -->
                    <div
                      v-if="uploadedUrls.length > 3"
                      @click="readMore = !readMore"
                      class="mt-1 text-xs text-blue-600 hover:text-blue-700 font-medium cursor-pointer"
                    >
                      {{ readMore ? "View Less" : "View More" }}
                    </div>
                  </div>
                </div>
                <div class="flex mt-6 items-center gap-2">
                  <input type="checkbox" id="Published" />
                  <label for="Published" class="text-sm">Published</label>
                </div>
                 <div class="flex mt-6 items-center gap-2">
                  <input type="checkbox" id="certificate" />
                  <label for="certificate" class="text-sm">Provide Certificate</label>
                </div>

                <!-- <div class="flex mt-6 items-center gap-2">
                  <input type="checkbox" id="course_permission" />
                  <label for="course_permission" class="text-sm"
                    >Course Permission</label
                  >
                </div> -->
                <div class="flex flex-row gap-4 items-center">
                  <input id="feedback" type="checkbox" />
                  <label for="feedback" class="text-sm font-medium">
                    Enable Feedback
                  </label>
                </div>
              </div>
              <!-- <div class="flex justify-between">
                <router-link :to="{ name: 'InstructorHome' }"
                  class=" bg-blues text-white rounded-lg text-lg font-semibold px-6 py-1.5">Back</router-link>
                <button type="submit" class="text-white bg-blues rounded-lg text-lg px-8 py-1.5">
                  Save
                </button>
              </div> -->
              <div class="flex gap-3 flex-wrap items-center">
                <button
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blue-500 hover:bg-blue-800 cursor-pointer text-white border-greens'
                  "
                  type="submit"
                  class="border rounded-lg text-lg font-semibold px-6 py-1.5"
                >
                  Save
                </button>

                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- section  -->
    <div
      v-if="isSection"
      @click.self="isSection = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isSection = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Section</h4>
        <form
          class="w-11/12 mx-auto pb-10"
          ref="addSectionRef"
          @submit.prevent="sectionAdd"
        >
          <label for="title">
            Name
            <span class="text-red-400">*</span>
          </label>
          <input
            id="name"
            type="text"
            required
            class="border border-gray-300 rounded-md text-sm w-full p-2"
          />

          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Section
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- add category  -->
    <div
      v-if="is_CategoryPopup"
      @click.self="is_CategoryPopup = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="is_CategoryPopup = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Category</h4>
        <form class="w-11/12 mx-auto pb-10" @submit.prevent="categoryAdd">
          <label for="title">
            Title
            <span class="text-red-400">*</span>
          </label>
          <input
            id="title"
            type="text"
            required
            class="border border-gray-300 rounded-md text-sm w-full p-2"
          />
          <!-- <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Category
          </button> -->
          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Category
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- Add Department -->
    <div
      v-if="isDepartment"
      @click.self="isDepartment = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isDepartment = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">
          Add Department
        </h4>
        <form
          class="w-11/12 mx-auto pb-10 flex flex-col gap-4"
          ref="addDepartment"
          @submit.prevent="AddDepartment"
        >
          <div class="flex flex-col gap-1">
            <label for="name">
              Program
              <span class="text-red-400">*</span>
            </label>
            <select
              id="program_name"
              required
              class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
            >
              <option
                v-for="program in programs"
                :key="program.id"
                :value="program.id"
              >
                {{ program.name }}
              </option>
            </select>
          </div>

          <div class="flex flex-col gap-1">
            <label for="name">
              Name
              <span class="text-red-400">*</span>
            </label>
            <input
              id="name"
              type="text"
              required
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>

          <!-- <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Department
          </button> -->
          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Department
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>

    <!-- Batch Popup -->
    <div
      v-if="isBatchs"
      @click.self="isBatchs = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isBatchs = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
        </div>
        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Batch</h4>
        <form
          class="w-11/12 mx-auto pb-10 flex flex-col gap-2"
          @submit.prevent="AddBatch"
        >
          <div class="flex flex-col gap-1">
            <label>Name <span class="text-red-400">*</span></label>
            <input
              id="batch_name"
              type="text"
              required
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>
          <div class="flex items-center gap-3 mt-4">
            <button
              :disabled="disable_submit"
              type="submit"
              class="bg-blues hover:bg-blue-600 text-white px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Batch
            </button>
            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- Program Popup -->
    <div
      v-if="isPrograms"
      @click.self="isPrograms = false"
      class="fixed inset-0 bg-black/50 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div class="w-11/12 md:w-2/3 xl:w-1/3 bg-white rounded-xl p-6 relative">
        <div
          @click="isPrograms = false"
          class="absolute top-4 right-4 cursor-pointer"
        >
          <img class="w-6 h-6" src="@/assets/closebutton.svg" />
        </div>
        <h3 class="text-xl font-bold text-center mb-6">Add Program</h3>

        <form @submit.prevent="AddPrograms" class="space-y-4">
          <!-- Batch -->
          <div class="flex flex-col gap-2">
            <label>
              Batch Year
              <span class="text-red-500">*</span>
            </label>

            <input
              v-if="currentBatchForProgram"
              :value="currentBatchForProgram"
              disabled
              class="bg-gray-100 border rounded-lg p-2"
            />
          </div>

          <!-- Program Name -->
          <div class="flex flex-col gap-2">
            <label>
              Program Name
              <span class="text-red-500">*</span>
            </label>

            <input
              id="program_name_input"
              type="text"
              required
              class="border rounded-lg p-2"
              placeholder="Enter Program Name"
            />
          </div>

          <div class="flex items-center gap-3 mt-4">
            <button
              :disabled="disable_submit"
              type="submit"
              class="bg-blues hover:bg-blue-600 text-white px-5 py-3 font-bold rounded-lg text-xs"
            >
              Add Program
            </button>
            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- Add Course Type -->
    <div
      v-if="isCourseTypePopup"
      @click.self="isCourseTypePopup = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isCourseTypePopup = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">
          Add Course Type
        </h4>
        <form
          class="w-11/12 mx-auto pb-10 flex flex-col gap-2"
          ref="addCourseTyperRef"
          @submit.prevent="addCourseType"
        >
          <div class="flex flex-col gap-1">
            <label for="name">
              Name
              <span class="text-red-400">*</span>
            </label>
            <input
              id="title"
              type="text"
              required
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>
          <!-- <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Course Type
          </button> -->
          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Course Type
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- Add Language -->
    <div
      v-if="addLanguage"
      @click.self="addLanguage = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="addLanguage = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Language</h4>
        <form
          class="w-11/12 mx-auto pb-10 flex flex-col gap-2"
          ref="addLangRef"
          @submit.prevent="addLanguagePost"
        >
          <div class="flex flex-col gap-1">
            <label for="name">
              Name
              <span class="text-red-400">*</span>
            </label>
            <input
              id="title"
              type="text"
              required
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>
          <!-- <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Language
          </button> -->
          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Language
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- Add Semester -->
    <!-- Semester Popup -->
    <div
      v-if="isSemesterAdd"
      @click.self="isSemesterAdd = false"
      class="fixed inset-0 bg-black/50 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div class="w-11/12 md:w-2/3 xl:w-1/3 bg-white rounded-xl p-6 relative">
        <div
          @click="isSemesterAdd = false"
          class="absolute top-4 right-4 cursor-pointer"
        >
          <img class="w-6 h-6" src="@/assets/closebutton.svg" />
        </div>
        <h3 class="text-xl font-bold text-center mb-6">Add Semester</h3>

        <form
          ref="addSemesterRef"
          @submit.prevent="addSemester"
          class="space-y-4"
        >
          <!-- Batch -->
          <div class="flex flex-col gap-2">
            <label>
              Batch Year
              <span class="text-red-500">*</span>
            </label>

            <input
              type="text"
              :value="selectedBatchName"
              disabled
              class="bg-gray-100 border rounded-lg p-3"
            />
          </div>

          <!-- Department -->
          <div class="flex flex-col gap-2">
            <label>
              Program
              <span class="text-red-500">*</span>
            </label>

            <input
              type="text"
              v-if="currentDepartmentForSemester"
              :value="currentDepartmentForSemester"
              disabled
              class="bg-gray-100 border rounded-lg p-3"
            />
          </div>

          <!-- Semester -->
          <div class="flex flex-col gap-2">
            <label>
              Semester
              <span class="text-red-500">*</span>
            </label>

            <input
              id="semester_name"
              type="text"
              maxlength="3"
              required
              class="border rounded-lg p-3"
              placeholder="Enter Semester"
            />
          </div>

          <div class="flex items-center gap-3 mt-4">
            <button
              :disabled="disable_submit"
              type="submit"
              class="bg-blues hover:bg-blue-600 text-white px-5 py-3 font-bold rounded-lg text-xs"
            >
              Add Semester
            </button>
            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>

    <div
      v-if="isVideoRetry"
      @click.self="isVideoRetry = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div class="flex items-center justify-center gap-3">
          <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
class FileUpload1 {
  constructor(input, bar_url, vueContext) {
    this.bar_url = bar_url;
    this.input = input;
    this.max_length = 1024 * 1024 * 1024 * 100;
    this.vue = vueContext;
  }

  create_progress_bar() {
    var progress = `<div class="file-icon">
                        <i class="fa fa-file-o" aria-hidden="true"></i>
                    </div>
                    <div class="file-details">

                         <p class="filename1"></p>
                        <small class="textbox1"></small>
                        <div class="progressbar1">
                            <div class="progress1" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%">
                            </div>
                        </div>
                    </div>`;
    document.getElementById(this.bar_url).innerHTML = progress;
  }

  upload(append_id) {
    this.create_progress_bar();
    this.initFileUpload(append_id);
  }

  initFileUpload(append_id) {
    this.file = this.input.files[0];
    this.upload_file(0, null, append_id);
  }

  //upload file
  upload_file(start, model_id, append_id) {
    var end;
    var self = this;
    var existingPath = model_id;
    var formData = new FormData();
    var nextChunk = start + this.max_length + 1;
    var currentChunk = this.file.slice(start, nextChunk);
    var uploadedChunk = start + currentChunk.size;
    if (uploadedChunk >= this.file.size) {
      end = 1;
    } else {
      end = 0;
    }

    formData.append("title", "title");

    formData.append("file", currentChunk);
    formData.append("filename", this.file.name);
    $(`.filename1`).text(this.file.name);
    $(`.textbox1`).text("Uploading file");
    formData.append("end", end);
    formData.append("existingPath", existingPath);
    formData.append("nextSlice", nextChunk);

    $.ajax({
      xhr: function () {
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", function (e) {
          if (e.lengthComputable) {
            if (self.file.size < self.max_length) {
              var percent = Math.round((e.loaded / e.total) * 100);
            } else {
              var percent = Math.round((uploadedChunk / self.file.size) * 100);
            }
            $(`.progress1`).css("width", percent + "%");
            $(`.progress1`).text(percent + "%");
          }
        });
        return xhr;
      },

      url: `${process.env.VUE_APP_API}/video-uploader/`,
      type: "POST",
      dataType: "json",
      cache: false,
      processData: false,
      contentType: false,
      data: formData,
      error: function (xhr) {
        alert(xhr.statusText);
      },
      success: function (res) {
        if (nextChunk < self.file.size) {
          // upload file in chunks
          existingPath = res.existingPath;
          self.upload_file(nextChunk, existingPath);
        } else {
          // upload complete
          $(`.textbox1`).text(res.data);
          $(`#${append_id}`)
            .val(`${process.env.VUE_APP_API}/media/` + res.existingPath)
            .trigger("input");
          self.vue.isValidUrl(append_id);
        }
      },
    });
  }
}

class FileUpload {
  constructor(input, bar_url, vueContext) {
    this.bar_url = bar_url;
    this.input = input;
    this.max_length = 1024 * 1024 * 1024 * 100;
    this.vue = vueContext;
  }

  create_progress_bar() {
    var progress = `<div class="file-icon">
                        <i class="fa fa-file-o" aria-hidden="true"></i>
                    </div>
                    <div class="file-details">

                         <p class="filename"></p>
                        <small class="textbox"></small>
                        <div class="progressbar">
                            <div class="progress" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%">
                            </div>
                        </div>
                    </div>`;
    document.getElementById(this.bar_url).innerHTML = progress;
  }

  upload(append_id) {
    this.create_progress_bar();
    this.initFileUpload(append_id);
  }

  initFileUpload(append_id) {
    this.file = this.input.files[0];
    this.upload_file(0, null, append_id);
  }

  //upload file
  upload_file(start, model_id, append_id) {
    var end;
    var self = this;
    var existingPath = model_id;
    var formData = new FormData();
    var nextChunk = start + this.max_length + 1;
    var currentChunk = this.file.slice(start, nextChunk);
    var uploadedChunk = start + currentChunk.size;
    if (uploadedChunk >= this.file.size) {
      end = 1;
    } else {
      end = 0;
    }

    formData.append("title", "title");

    formData.append("file", currentChunk);
    formData.append("filename", this.file.name);
    $(`.filename`).text(this.file.name);
    $(`.textbox`).text("Uploading file");
    formData.append("end", end);
    formData.append("existingPath", existingPath);
    formData.append("nextSlice", nextChunk);

    $.ajax({
      xhr: function () {
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", function (e) {
          if (e.lengthComputable) {
            if (self.file.size < self.max_length) {
              var percent = Math.round((e.loaded / e.total) * 100);
            } else {
              var percent = Math.round((uploadedChunk / self.file.size) * 100);
            }
            $(`.progress`).css("width", percent + "%");
            $(`.progress`).text(percent + "%");
          }
        });
        return xhr;
      },

      url: `${process.env.VUE_APP_API}/video-uploader/`,
      type: "POST",
      dataType: "json",
      cache: false,
      processData: false,
      contentType: false,
      data: formData,
      error: function (xhr) {
        alert(xhr.statusText);
        // self.vue.EnableRetry();
      },
      success: function (res) {
        if (nextChunk < self.file.size) {
          // upload file in chunks
          existingPath = res.existingPath;
          self.upload_file(nextChunk, existingPath);
        } else {
          // upload complete
          $(`.textbox`).text(res.data);
          $(`#${append_id}`)
            .val(`${process.env.VUE_APP_API}/media/` + res.existingPath)
            .trigger("input");
          self.vue.isValidUrl(append_id);
        }
      },
    });
  }
}

import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: {
    Header,
    QuillEditor,
    FlashMessage,
    HodHeader,
    CoordinateHeader,
  },

  // props: ["batchYear", "departmentName", "programName", "semesterName"],

  data() {
    return {
      categories: null,
      info: null,
      msgverify: "",
      messages: {
        text: "",
        type: "null",
      },
      // is_CategoryPopup: false,
      description: "<h4>Write your course content</h4>",
      batch_years: [],
      programs: [],
      departments: [],
      // isDepartment: false,
      // isPrograms: false,
      // isBatchs: false,
      instructor_lists: [],
      courseTypeList: [],
      // isCourseTypePopup: false,
      // addLanguage: false,
      languageList: [],
      semetser_list: [],
      // isSemesterAdd: false,
      sections: [],

      formsDetails: [
        {
          batch_id: "",
          department_id: "",
          program_id: "",
          semester_id: "",
          section_id: "",
          instructor_id: [],
          departments: [],
          semetser_list: [],
          instructor_lists: [],
        },
      ],
      isValidUrlBool: {
        video_url: false,
        pdf_urls: false,
      },
      isDynamic: false,
      // isSection: false,
      errorMessage: "",
      errorgreenMessage: "",
      disable_submit: false,
      isVideoRetry: false,
      video_error: "",
      pdf_error: "",

      chunkSize: 1024 * 1024,
      // chunkIndex: 0,
      // totalChunks: 0,
      // file: null,
      files: {
        pdf: { file: null, chunkIndex: 0, totalChunks: 0 },
        video: { file: null, chunkIndex: 0, totalChunks: 0 },
      },
      // title: "Sample File",
      // pdfDisabled: true,
      keywords: "",
      // currentProgramIndex: null,
      currentDepartmentIndex: null,

      // newMultiple file
      currentFileIndex: 0,
      uploadedUrls: [],
      url_list: "",
      filesQueue: [],
      video_url: "",
      readMore: false,
      errors: {},
      // Popup states
      isSection: false,
      isBatchs: false,
      isPrograms: false,
      isSemesterAdd: false,
      isCourseTypePopup: false,
      addLanguage: false,
      isDepartment: false,
      is_CategoryPopup: false,

      // Current selections for popups
      currentBatchIndex: null,
      currentProgramIndex: null,
      currentBatchForProgram: null,
      currentProgramForSemester: null,
      currentDepartmentForSemester: null,
      currentDepartmentId: null,
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
    pdfDisabled() {
      return this.keywords.trim() === "";
    },
    displayedUrls() {
      // Show first 3 URLs by default; if readMore is true, show all (4 in this case)
      return this.readMore ? this.uploadedUrls : this.uploadedUrls.slice(0, 3);
    },
    selectedBatchName() {
      const batch = this.batch_years.find(
        (item) => item.id == this.formsDetails[0].batch_id,
      );

      return batch ? batch.year : "";
    },
  },

  mounted() {
    const script = document.createElement("script");
    script.src =
      "https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js";
    script.onload = () => {
      this.initJQuery();
    };
    document.head.appendChild(script);
  },

  async created() {
    // this.getDepartments();
    // this.getPrograms();
    await this.getBatchList();
    this.getCourseTypeList();
    this.getLanguages();
    this.sectionsGet();

    // this.getInstructorListByFilter();

    axios
      .get(`${process.env.VUE_APP_API}/category/?format=json`)
      .then((res) => {
        this.categories = res.data.data;
      });
  },

  methods: {
    async getBatchList() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`,
        );

        this.batch_years = res.data.data || [];
      } catch (error) {
        console.log(error);
      }
    },

    openBatchPopup(index) {
      this.currentBatchIndex = index;
      this.isBatchs = true;
    },

    openProgramPopup(index) {
      const form = this.formsDetails[index];

      if (!form.batch_id) {
        this.messages = {
          text: "Please select Batch first",
          type: "error",
        };
        setTimeout(() => {
          this.messages = {
            text: "",
            type: "null",
          };
        }, 2000);
        return;
      }

      this.currentProgramIndex = index;

      const batch = this.batch_years.find((item) => item.id === form.batch_id);

      this.currentBatchForProgram = batch?.year || "";

      this.isPrograms = true;
    },

    openSemesterPopup(index) {
      const form = this.formsDetails[index];

      if (!form.department_id) {
        this.messages = {
          text: "Please select Program first",
          type: "error",
        };
        setTimeout(() => {
          this.messages = {
            text: "",
            type: "null",
          };
        }, 2000);
        return;
      }

      this.currentProgramIndex = index;
      this.currentDepartmentId = form.department_id;
      const department = form.departments?.find(
        (item) => item.id === form.department_id,
      );
      this.currentDepartmentForSemester = department?.name || "";
      this.isSemesterAdd = true;
    },

    openSectionPopup() {
      this.isSection = true;
    },
    async onBatchChange(index, batchId) {
      const form = this.formsDetails[index];

      if (!batchId) {
        this.resetFormGroup(index);
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/program-list/?batch__id=${batchId}&Key=${this.userInfo.token_key}`,
        );

        form.programs = res.data.data || [];

        form.program_id = "";
        form.department_id = "";
        form.semester_id = "";
        form.section_id = "";
        form.instructor_id = [];

        form.departments = [];
        form.semetser_list = [];
        form.instructor_lists = [];
      } catch (error) {
        console.log(error);
      }
    },
    async onProgramChange(index, programId) {
      const form = this.formsDetails[index];

      if (!programId) {
        form.department_id = "";
        form.departments = [];
        form.semetser_list = [];
        form.instructor_lists = [];
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/department-list/?program__id=${programId}&Key=${this.userInfo.token_key}`,
        );

        form.departments = res.data.data || [];

        // Auto Select Department
        if (form.departments.length > 0) {
          form.department_id = form.departments[0].id;

          await this.loadSemestersAndInstructors(index, form.department_id);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async loadSemestersAndInstructors(index, departmentId) {
      const form = this.formsDetails[index];

      try {
        const semesterRes = await axios.get(
          `${process.env.VUE_APP_API}/semetser-get/?department__id=${departmentId}&batch__id=${form.batch_id}&Key=${this.userInfo.token_key}`,
        );

        form.semetser_list = semesterRes.data.data || [];

        // Auto Select First Semester
        if (form.semetser_list.length > 0) {
          form.semester_id = form.semetser_list[0].id;
        }

        const instructorRes = await axios.get(
          `${process.env.VUE_APP_API}/instructor_all/?department__id=${departmentId}&Key=${this.userInfo.token_key}`,
        );

        form.instructor_lists = instructorRes.data.products || [];
      } catch (error) {
        console.log(error);
      }
    },

    async AddBatch() {
      this.disable_submit = true;

      const batchName = document.getElementById("batch_name").value;

      try {
        // Validation API
        const validationRes = await axios.get(
          `${process.env.VUE_APP_API}/batch-validation/?year=${batchName}&Key=${this.userInfo.token_key}`,
        );

        if (validationRes.data.status !== 200) {
          this.messages = {
            text: validationRes.data.message || "Batch already exists",
            type: "error",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 2000);

          this.disable_submit = false;
          return;
        }

        // Create Batch
        const response = await axios.post(
          `${process.env.VUE_APP_API}/batch-create/?Key=${this.userInfo.token_key}`,
          {
            year: batchName,
          },
        );

        if (response.data.status === 200) {
          await this.getBatchList();

          const newBatch = response.data.data;

          if (newBatch && this.currentBatchIndex !== null) {
            const form = this.formsDetails[this.currentBatchIndex];

            form.batch_id = newBatch.id;

            await this.onBatchChange(this.currentBatchIndex, newBatch.id);
          }

          this.messages = {
            text: "Batch Added Successfully",
            type: "success",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };

            this.isBatchs = false;

            if (this.$refs.addBatchRef) {
              this.$refs.addBatchRef.reset();
            }
          }, 1500);
        } else {
          this.messages = {
            text: response.data.message,
            type: "error",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 2000);
        }
      } catch (error) {
        this.messages = {
          text: error.response?.data?.message || "Validation failed",
          type: "error",
        };

        setTimeout(() => {
          this.messages = {
            text: "",
            type: "null",
          };
        }, 2000);
      } finally {
        this.disable_submit = false;
      }
    },
    async AddPrograms() {
      this.disable_submit = true;

      const programName = document.getElementById("program_name_input").value;
      const form = this.formsDetails[this.currentProgramIndex];

      try {
        // Program Validation
        const validationRes = await axios.get(
          `${process.env.VUE_APP_API}/program-validation/?batch_id=${form.batch_id}&name=${programName}&Key=${this.userInfo.token_key}`,
        );

        if (validationRes.data.status !== 200) {
          this.messages = {
            text: validationRes.data.message || "Program already exists",
            type: "error",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 2000);

          this.disable_submit = false;
          return;
        }

        // Create Program
        const response = await axios.post(
          `${process.env.VUE_APP_API}/program_create/?Key=${this.userInfo.token_key}`,
          {
            batch: form.batch_id,
            name: programName,
          },
        );

        if (response.data.status === 200) {
          const newProgram = response.data.data;

          // Refresh Program List
          await this.onBatchChange(this.currentProgramIndex, form.batch_id);

          // Select Program
          form.program_id = newProgram.id;

          // Create Department
          const departmentData = await this.AddDepartment(newProgram);

          if (departmentData) {
            form.department_id = departmentData.id;

            form.departments = [departmentData];

            await this.loadSemestersAndInstructors(
              this.currentProgramIndex,
              departmentData.id,
            );
          }

          this.messages = {
            text: response.data.message,
            type: "success",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };

            this.isPrograms = false;

            if (this.$refs.addProgramRef) {
              this.$refs.addProgramRef.reset();
            }
          }, 1500);
        } else {
          this.messages = {
            text: response.data.message,
            type: "error",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 2000);
        }
      } catch (error) {
        this.messages = {
          text: error.response?.data?.message || "Validation failed",
          type: "error",
        };

        setTimeout(() => {
          this.messages = {
            text: "",
            type: "null",
          };
        }, 2000);
      } finally {
        this.disable_submit = false;
      }
    },
    async AddDepartment(programData) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/department_create/?Key=${this.userInfo.token_key}`,
          {
            name: programData.name,
            program: programData.id,
          },
        );

        if (response.data.status === 200) {
          return response.data.data;
        }

        return null;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    async addSemester() {
      const form = this.formsDetails[this.currentProgramIndex];

      const semesterName = document.getElementById("semester_name").value;

      try {
        // Semester Validation
        const validationRes = await axios.get(
          `${process.env.VUE_APP_API}/semester-validation/?department_id=${form.department_id}&batch_id=${form.batch_id}&semester=${semesterName}&Key=${this.userInfo.token_key}`,
        );

        if (validationRes.data.status !== 200) {
          this.messages = {
            text: validationRes.data.message || "Semester already exists",
            type: "error",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 2000);

          return;
        }

        // Create Semester
        const response = await axios.post(
          `${process.env.VUE_APP_API}/semetser-create/?Key=${this.userInfo.token_key}`,
          {
            semester: semesterName,
            department: form.department_id,
            batch: form.batch_id,
          },
        );

        if (response.data.status === 200) {
          await this.loadSemestersAndInstructors(
            this.currentProgramIndex,
            form.department_id,
          );

          form.semester_id = response.data.data.id;

          this.messages = {
            text: response.data.message,
            type: "success",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };

            this.isSemesterAdd = false;

            if (this.$refs.addSemesterRef) {
              this.$refs.addSemesterRef.reset();
            }
          }, 1500);
        } else {
          this.messages = {
            text: response.data.message,
            type: "error",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 2000);
        }
      } catch (error) {
        this.messages = {
          text: error.response?.data?.message || "Validation failed",
          type: "error",
        };

        setTimeout(() => {
          this.messages = {
            text: "",
            type: "null",
          };
        }, 2000);

        console.log(error);
      }
    },
    sectionAdd() {
      this.disable_submit = true;
      axios
        .post(
          `${process.env.VUE_APP_API}/section-create/?Key=${this.userInfo.token_key}`,
          { name: document.getElementById("name").value },
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Section Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.sectionsGet();
              this.isSection = false;
              this.$refs.addSectionRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    resetFormGroup(index) {
      const form = this.formsDetails[index];

      form.program_id = "";
      form.department_id = "";
      form.semester_id = "";
      form.section_id = "";
      form.instructor_id = [];

      form.programs = [];
      form.departments = [];
      form.semetser_list = [];
      form.instructor_lists = [];
    },
    truncate(url, length) {
      if (url.length <= length) return url;
      return url.slice(0, length) + "...";
    },

    checkPdfSizes(event) {
      const files = Array.from(event.target.files);
      const maxSize = 50 * 1024 * 1024;
      const validFiles = [];

      files.forEach((file) => {
        if (file.size > maxSize) {
          this.pdf_error = `${file.name} exceeds 50MB and was skipped.`;
          setTimeout(() => (this.pdf_error = ""), 5000);
        } else {
          validFiles.push(file);
        }
      });

      this.filesQueue = validFiles;
    },

    uploadFilesSequential() {
      if (!this.filesQueue.length) {
        alert("No valid PDF files selected.");
        return;
      }
      this.currentFileIndex = 0;
      this.uploadNextPdf();
    },

    uploadNextPdf() {
      if (this.currentFileIndex >= this.filesQueue.length) return;
      const file = this.filesQueue[this.currentFileIndex];
      const totalChunks = Math.ceil(file.size / this.chunkSize);
      this.uploadChunkPdf(file, 0, totalChunks);
    },

    uploadChunkPdf(file, chunkIndex, totalChunks) {
      const start = chunkIndex * this.chunkSize;
      const end = Math.min(file.size, start + this.chunkSize);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("filename", file.name);
      formData.append("chunkIndex", chunkIndex);
      formData.append("totalChunks", totalChunks);
      formData.append("title", this.title);

      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        `${process.env.VUE_APP_API}/video_uploader/chunk/`,
        true,
      );

      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);

          document.getElementById("statusCodePdf").innerText = response.message;

          if (chunkIndex + 1 < totalChunks) {
            this.uploadChunkPdf(file, chunkIndex + 1, totalChunks);
          } else {
            const pdfUrl = response.video_url;
            if (pdfUrl) {
              this.uploadedUrls.push(pdfUrl);
              this.url_list = this.uploadedUrls.join(", ");
            }
            alert(`${file.name} uploaded successfully!`);
            this.currentFileIndex++;
            this.uploadNextPdf();
          }
        } else {
          alert(`Upload failed for ${file.name}: ${xhr.responseText}`);
        }
      };

      xhr.send(formData);
    },
    // old
    uploadFilebyChunkNew(file_id, append_id, type) {
      const fileInput = document.getElementById(`${file_id}`);
      const file = fileInput.files[0];
      if (!file) {
        alert("Please select a file.");
        return;
      }
      // this.file = file;
      // this.totalChunks = Math.ceil(file.size / this.chunkSize);
      // this.chunkIndex = 0;
      // this.sendChunk(append_id);
      this.files[type].file = file;
      this.files[type].totalChunks = Math.ceil(file.size / this.chunkSize);
      this.files[type].chunkIndex = 0;
      this.sendChunk(append_id, type);
    },

    sendChunk(append_id, type) {
      const { file, chunkIndex, totalChunks } = this.files[type];
      const start = chunkIndex * this.chunkSize;
      const end = Math.min(file.size, start + this.chunkSize);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("filename", file.name);
      formData.append("chunkIndex", chunkIndex);
      formData.append("totalChunks", totalChunks);
      formData.append("title", this.title);

      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        `${process.env.VUE_APP_API}/video_uploader/chunk/`,
        true,
      );
      // xhr.setRequestHeader("X-CSRFToken", getCSRFToken());

      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);

          // Update individual status message
          const statusDivId =
            type === "pdf" ? "statusCodePdf" : "statusCodeVideo";
          document.getElementById(statusDivId).innerText = response.message;

          if (response.video_url || response.pdf_url) {
            const fullUrl = response.video_url || response.pdf_url;
            document.getElementById(`${append_id}`).value = fullUrl;
          }

          this.files[type].chunkIndex++;
          if (this.files[type].chunkIndex < this.files[type].totalChunks) {
            this.sendChunk(append_id, type);
          } else {
            alert(`${type.toUpperCase()} upload complete!`);
          }
        } else {
          alert(`${type.toUpperCase()} upload failed: ` + xhr.responseText);
        }
      };

      xhr.send(formData);
    },

    CheckPdfSizeUpload(event) {
      const file = event.target.files[0];
      const maxSize = 50 * 1024 * 1024;
      if (file.size > maxSize) {
        this.pdf_error =
          "Pdf file is larger than 50MB. Please choose a smaller file.";
        event.target.value = "";
        setTimeout(() => {
          this.pdf_error = "";
        }, 5000);
      } else {
        this.pdf_error = "";
      }
    },

    CheckVideoSizeUpload(event) {
      // const file = event.target.files[0];
      // const maxSize = 300 * 1024 * 1024;
      // if (file.size > maxSize) {
      //   this.video_error = 'Video file is larger than 300MB. Please choose a smaller file.';
      //   event.target.value = '';
      //   setTimeout(()=>{
      //     this.video_error = '';
      //   }, 5000)
      // } else {
      //   this.video_error = '';
      // }
    },

    EnableRetry() {
      this.EnableRetry = true;
    },
    convertTimeOnBlur() {
      // const el = document.getElementById("total_contact_hours");
      if (!el) return;

      const raw = el.value.trim().replace(/\D/g, "");

      let hours = "00";
      let minutes = "00";

      if (raw.length === 1) {
        hours = `0${raw}`;
      } else if (raw.length === 2) {
        hours = raw;
      } else if (raw.length === 3) {
        hours = raw.slice(0, 2);
        minutes = `${raw[2]}0`;
      } else if (raw.length === 4) {
        hours = raw.slice(0, 2);
        minutes = raw.slice(2, 4);
      } else {
        el.value = "";
        return;
      }

      el.value = `${hours}:${minutes}`;
    },

    // async validateCourseCode() {
    //   this.course_code = document.getElementById("course_code").value;
    //   axios
    //     .get(
    //       `${process.env.VUE_APP_API}/course/code/checker/?course_code=${this.course_code}&Key=${this.userInfo.token_key}`,
    //     )
    //     .then((response) => {
    //       if (response.data.status == 200) {
    //         // this.errorgreenMessage=response.data.message;
    //         // this.errorgreenMessage =
    //         //   "course code vaild";
    //         this.errorMessage = "";
    //       } else if (response.data.status == 400) {
    //         this.errorMessage = response.data.message;
    //       }
    //     });
    // },

    initJQuery() {
      $(document).ready(() => {
        console.log("jQuery is ready in this component");
      });
    },

    // sectionAdd() {
    //   this.disable_submit = true;
    //   axios
    //     .post(
    //       `${process.env.VUE_APP_API}/section-create/?Key=${this.userInfo.token_key}`,
    //       { name: document.getElementById("name").value },
    //     )
    //     .then((response) => {
    //       this.disable_submit = false;
    //       if (response.data.status == 200) {
    //         this.messages = {
    //           text: "Section Added successfully",
    //           type: "success",
    //         };
    //         setTimeout(() => {
    //           this.messages = {
    //             text: "",
    //             type: "null",
    //           };
    //           this.sectionsGet();
    //           this.isSection = false;
    //           this.$refs.addSectionRef.reset();
    //         }, 1500);
    //       } else {
    //         this.messages = {
    //           text: response.data.message,
    //           type: "error",
    //         };
    //         setTimeout(() => {
    //           this.messages = {
    //             text: "",
    //             type: "null",
    //           };
    //         }, 2000);
    //       }
    //     });
    // },

    videoUploadURL(id, bar_url) {
      var uploader = new FileUpload(
        document.querySelector(`#${id}`),
        bar_url,
        this,
      );
      uploader.upload("video_url");
    },

    pdfUploadURL(id, bar_url) {
      var uploader = new FileUpload1(
        document.querySelector(`#${id}`),
        bar_url,
        this,
      );
      uploader.upload("pdf_urls");
    },

    isValidUrl(id) {
      // let id = document.getElementById(id).value;
      try {
        new URL(document.getElementById(id).value);
        this.isValidUrlBool[id] = true;
        // return true;
      } catch (err) {
        this.isValidUrlBool[id] = false;
        // return false;1
      }
    },

    validateNumber(id) {
      let number = document.getElementById(id).value;
      if (number > 99) {
        document.getElementById(id).value = 99;
      }
      // } else if (number < 1) {
      //   document.getElementById(id).value = 1;
      // }
    },

    addFormInput() {
      this.formsDetails.push({
        batch_id: "",
        program_id: "",
        department_id: "",
        semester_id: "",
        section_id: "",
        instructor_id: [],
        departments: [],
        semetser_list: [],
        instructor_lists: [],
        isDynamic: true,
      });
    },
    cancelForm(index) {
      if (this.formsDetails[index].isDynamic) {
        this.formsDetails.splice(index, 1);
      }
    },
    addNumber() {
      document.getElementById("total").value =
        parseInt(document.getElementById("cie").value) +
        parseInt(document.getElementById("see").value);
    },

    closeEmit() {
      this.$emit("close-Emit");
    },

    sectionsGet() {
      axios
        .get(
          `${process.env.VUE_APP_API}/section-list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.sections = res.data.data;
        });
    },

    // addSemester(el) {
    //   this.disable_submit = true;
    //   let bodyVal = {
    //     semester: el.target.elements.semester.value,
    //     department: this.department,
    //     batch: 1,
    //   };

    //   axios
    //     .post(
    //       `${process.env.VUE_APP_API}/semetser-create/?Key=${this.userInfo.token_key}`,
    //       bodyVal,
    //     )
    //     .then((response) => {
    //       if (response.data.status == 200) {
    //         this.messages = {
    //           text: "Semester Added successfully",
    //           type: "success",
    //         };
    //         setTimeout(() => {
    //           this.messages = {
    //             text: "",
    //             type: "null",
    //           };
    //           this.isSemesterAdd = false;
    //           this.disable_submit = false;
    //           // window.location.reload();
    //           this.getSemesterFilter(
    //             this.currentDepartmentIndex,
    //             response.data.data.department,
    //           );
    //           this.$refs.addSemesterRef.reset();
    //         }, 1500);
    //       } else {
    //         this.messages = {
    //           text: response.data.message,
    //           type: "error",
    //         };
    //         setTimeout(() => {
    //           this.messages = {
    //             text: "",
    //             type: "null",
    //           };
    //         }, 2000);
    //       }
    //     });
    // },

    getSemesterFilter(index, department_id) {
      this.currentDepartmentIndex = index;
      let batch_year = 1;
      // let department_name = document.getElementById("department").value;
      console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__id=${department_id}&batch__id=${batch_year}`,
        )
        .then((res) => {
          // this.semetser_list = res.data.data;
          this.formsDetails[index].semetser_list = res.data.data;
        });
    },

    getLanguages() {
      axios
        .get(
          `${process.env.VUE_APP_API}/language/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.languageList = res.data.data;
        });
    },

    addLanguagePost(el) {
      this.disable_submit = true;
      let bodyVal = {
        title: el.target.elements.title.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/language/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Language Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.addLanguage = false;
              this.getLanguages();
              this.$refs.addLangRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    addCourseType(el) {
      this.disable_submit = true;
      let bodyVal = {
        title: el.target.elements.title.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Course Type Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isCourseTypePopup = false;
              this.getCourseTypeList();
              this.$refs.addCourseTyperRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    getCourseTypeList() {
      axios
        .get(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.courseTypeList = res.data.data;
        });
    },

    getInstructorListByFilter(index, department_id) {
      // let department_name = document.getElementById("department").value;
      console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          // this.instructor_lists = res.data.products;
          this.formsDetails[index].instructor_lists = res.data.products;
        });
    },

    getProgramsFilterBYid() {
      let program = document.getElementById("program").value;
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${program}`,
        )
        .then((res) => {
          // this.departments = res.data.data;
          this.departments = res.data.data.map((item) => ({
            id: item.id,
            name: item.name,
          }));
          if (this.departments.length > 0) {
            this.department = this.departments[0].id;
          }
          console.log("Departments:", this.department);
        });
    },

    getProgramsFilter(index, program_id) {
      this.currentProgramIndex = index;

      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${program_id}`,
        )
        .then((res) => {
          // this.departments = res.data.data;
          if (!this.formsDetails[index]) {
            this.formsDetails[index] = {
              departments: [],
            };
          }

          this.formsDetails[index].departments = res.data.data;

          if (
            this.formsDetails[index].departments &&
            this.formsDetails[index].departments.length > 0
          ) {
            const firstDepartmentId =
              this.formsDetails[index].departments[0].id;
            this.formsDetails[index].department_id = firstDepartmentId;

            this.getInstructorListByFilter(index, firstDepartmentId);

            this.getSemesterFilter(index, firstDepartmentId);
          }
        });
    },
    // AddPrograms(el) {
    //   this.disable_submit = true;
    //   let bodyVal = {
    //     name: el.target.elements.name.value,
    //   };

    //   axios
    //     .post(
    //       `${process.env.VUE_APP_API}/program_create/?Key=${this.userInfo.token_key}`,
    //       bodyVal,
    //     )
    //     .then((response) => {
    //       this.disable_submit = false;
    //       if (response.data.status == 200) {
    //         this.messages = {
    //           text: "Program Added successfully",
    //           type: "success",
    //         };
    //         setTimeout(() => {
    //           this.messages = {
    //             text: "",
    //             type: "null",
    //           };
    //           this.isPrograms = false;
    //           this.getPrograms();
    //           this.AddDepartment(response.data.data);
    //           this.$refs.addProgramsRef.reset();
    //         }, 1500);
    //       } else {
    //         this.messages = {
    //           text: response.data.message,
    //           type: "error",
    //         };
    //         setTimeout(() => {
    //           this.messages = {
    //             text: "",
    //             type: "null",
    //           };
    //         }, 2000);
    //       }
    //     });
    // },

    // AddBatch(el) {
    //   this.disable_submit = true;
    //   let bodyVal = {
    //     year: el.target.elements.name.value,
    //   };

    //   axios
    //     .post(
    //       `${process.env.VUE_APP_API}/batch-create/?Key=${this.userInfo.token_key}`,
    //       bodyVal,
    //     )
    //     .then((response) => {
    //       this.disable_submit = false;
    //       if (response.data.status == 200) {
    //         this.messages = {
    //           text: "Batch Added successfully",
    //           type: "success",
    //         };
    //         setTimeout(() => {
    //           this.messages = {
    //             text: "",
    //             type: "null",
    //           };
    //           this.isBatchs = false;
    //           this.getBatchList();
    //           this.$refs.addProgramsRef.reset();
    //         }, 1500);
    //       } else {
    //         this.messages = {
    //           text: response.data.message,
    //           type: "error",
    //         };
    //         setTimeout(() => {
    //           this.messages = {
    //             text: "",
    //             type: "null",
    //           };
    //         }, 2000);
    //       }
    //     });
    // },

    getPrograms(index, batchId) {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?batch__id=${batchId}&Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.programs = res.data.data;
        });
    },

    getDepartments() {
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          // this.departments = res.data.data;
          this.departments = res.data.data.map((item) => ({
            id: item.id,
            name: item.name,
          }));
          if (this.departments.length > 0) {
            this.department = this.departments[0].id;
          }
        });
    },

    categoryget() {
      axios
        .get(`${process.env.VUE_APP_API}/category/?format=json`)
        .then((res) => {
          this.categories = res.data.data;
        });
    },

    AddDepartment(el) {
      this.disable_submit = true;
      let bodyVal = {
        name: el.name,
        program: el.id,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/department_create/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            // this.messages = {
            //   text: "Department Added successfully",
            //   type: "success",
            // };
            setTimeout(() => {
              // this.messages = {
              //   text: "",
              //   type: "null",
              // };
              // this.isDepartment = false;
              this.getDepartments();
              this.getProgramsFilter(
                this.currentProgramIndex,
                response.data.data.program,
              );
              // this.$refs.addDepartment.reset();
            }, 1500);
          } else {
            // this.messages = {
            //   text: response.data.message,
            //   type: "error",
            // };
            // setTimeout(() => {
            //   this.messages = {
            //     text: "",
            //     type: "null",
            //   };
            // }, 2000);
          }
        });
    },

    categoryAdd(el) {
      this.disable_submit = true;
      let bodyVal = {
        title: el.target.elements.title.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/categorynew/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.message == "your Category added successfully") {
            this.messages = {
              text: "Category Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.is_CategoryPopup = false;
              this.categoryget();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    async createCourse(e) {
      this.disable_submit = true;
      let token = this.userInfo.token_key;

      this.description = document.querySelector(".ql-editor").innerHTML;

      // let urls = `${process.env.VUE_APP_API}/coursenew/?Key=${token}`;

      let urls = `${process.env.VUE_APP_API}/course-doc-create/?Key=${token}`;

      let HeaderVal = new FormData();
      if (e.target.elements.thumbnail.files.length > 0) {
        var thumbnailVal = e.target.elements.thumbnail.files[0];
        HeaderVal.append("thumbnail", thumbnailVal);
      }

      HeaderVal.append("course_type", e.target.elements.course_type.value);
      // HeaderVal.append("batch_year", e.target.elements.batch_year.value);

      // HeaderVal.append("batch_year", "2024-25");
      // HeaderVal.append("program_name", e.target.elements.program_name.value);
      // HeaderVal.append("department_name", e.target.elements.department.value);
      // HeaderVal.append("semester", e.target.elements.semester.value);

      // HeaderVal.append("batch[]", this.formsDetails.map(f => f.batch_id));
      // HeaderVal.append("program[]", this.formsDetails.map(f => f.program_id));
      // HeaderVal.append("department[]", this.formsDetails.map(f => f.department_id));
      // HeaderVal.append("semester[]", this.formsDetails.map(f => f.semester_id));
      // HeaderVal.append("class_section[]", this.formsDetails.map(f => f.section_id));
      // HeaderVal.append("instructor[]", this.formsDetails.map(f => f.instructor_id));

      this.formsDetails.forEach((f) => {
        HeaderVal.append("batch", Number(f.batch_id));
        HeaderVal.append("program", Number(f.program_id));
        HeaderVal.append("department", Number(f.department_id));
        HeaderVal.append("semester", Number(f.semester_id));
        HeaderVal.append("class_section", Number(f.section_id));
        // HeaderVal.append("instructor", Number(f.instructor_id));

        if (Array.isArray(f.instructor_id)) {
          const plainArray = [...f.instructor_id];
          plainArray.forEach((id) => {
            HeaderVal.append("instructor", Number(id));
          });
        } else {
          HeaderVal.append("instructor", Number(f.instructor_id));
        }
      });

      // HeaderVal.append("tutor_hours", e.target.elements.tutor_hours.value);
      // HeaderVal.append("practical_hours", e.target.elements.practical_hours.value);
      // HeaderVal.append("ltp", e.target.elements.ltp.value);

      HeaderVal.append("credits", e.target.elements.credits.value);
      HeaderVal.append("exam_duration", e.target.elements.exam_duration.value);
      HeaderVal.append("total", e.target.elements.total.value);
      HeaderVal.append("cie", e.target.elements.cie.value);
      HeaderVal.append("see", e.target.elements.see.value);
      // HeaderVal.append(
      //   "total_contact_hours",
      //   e.target.elements.total_contact_hours.value
      // );
      // HeaderVal.append(
      //   "no_of_contact_hours",
      //   e.target.elements.no_of_contact_hours.value
      // );

      // HeaderVal.append("batch_year", this.batchYear);
      // HeaderVal.append("program_name", this.programName);
      // HeaderVal.append("department_name", this.departmentName);
      // HeaderVal.append("semester", this.semesterName);

      HeaderVal.append("title", e.target.elements.title.value);
      // HeaderVal.append("category", parseInt(e.target.elements.category.value));
      HeaderVal.append(
        "short_description",
        e.target.elements["short-desc"].value,
      );
      // HeaderVal.append("description", this.description);
      HeaderVal.append("description", this.description);
      HeaderVal.append("outcome", e.target.elements.outcome.value);
      HeaderVal.append("requirements", e.target.elements.requirement.value);
      HeaderVal.append("languages", e.target.elements.languages.value);
      HeaderVal.append("price", 0);
      HeaderVal.append("course_free", true);
      HeaderVal.append("level", "0");
      HeaderVal.append("video_url", e.target.elements.video_url.value);
      HeaderVal.append("ordered", e.target.elements.order.value);

      HeaderVal.append("is_published", e.target.elements.Published.checked);
      // HeaderVal.append("organization_id", this.userInfo.organizes_id);
      HeaderVal.append("course_code", e.target.elements.course_code.value);

      // HeaderVal.append("pdf_urls", e.target.elements.pdf_urls.value);
      HeaderVal.append("url_list", this.url_list);

      // HeaderVal.append(
      //   "course_permission",
      //   e.target.elements.course_permission.checked,
      // );
      HeaderVal.append("feedback", e.target.elements.feedback.checked);
      HeaderVal.append("certificate_enable", e.target.elements.certificate.checked);


      await axios
        .post(urls, HeaderVal, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.addCourseRef.reset();
              // this.closeEmit();
              this.$router.push({
                name: "AdminCoursess",
              });
            }, 1500);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        })
        .catch((err) => {
          this.disable_submit = false;

          if (err.response?.data) {
            this.errors = err.response.data;

            // Global Error Message
            if (err.response.data.non_field_errors) {
              this.messages = {
                text: err.response.data.non_field_errors[0],
                type: "error",
              };
            } else {
              this.messages = {
                text: "Please fix the validation errors",
                type: "error",
              };
            }

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          } else {
            this.messages = {
              text: "Event Error",
              type: "error",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
